// useKnowledgeBaseStore — a Zustand store that holds the Knowledge Base list state.
// Same idea as useProjectsStore: the list lives in one shared place so the page can
// render instantly from it and refresh in the background (no full-page reload).
//
// The KB page owns the actual fetch (it also preserves in-progress upload statuses
// and loads column preferences), so this store is a shared STATE CONTAINER. The
// setters accept either a value or an updater function — exactly like React's
// setState — so existing `setContracts((prev) => ...)` call sites keep working.
import { create } from "zustand";

const useKnowledgeBaseStore = create((set) => ({
  // ── STATE
  documents: [], // display list of KB files (was: `contracts`)
  results: [], // full/unfiltered list, used for the "is KB empty?" check
  folders: [], // KB folders (each may contain documents)
  loading: false, // true only during a non-silent fetch (drives the page spinner)

  // ── ACTIONS (value OR updater function, like setState)
  setDocuments: (updater) =>
    set((state) => ({
      documents:
        typeof updater === "function" ? updater(state.documents) : updater,
    })),

  setResults: (updater) =>
    set((state) => ({
      results: typeof updater === "function" ? updater(state.results) : updater,
    })),

  setFolders: (updater) =>
    set((state) => ({
      folders: typeof updater === "function" ? updater(state.folders) : updater,
    })),

  setLoading: (value) => set({ loading: !!value }),
}));

export default useKnowledgeBaseStore;
